import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../../theme';

import {Table, TableHead, TableBody, TableCell, TableRow} from '@material-ui/core';
import {Paper} from '@material-ui/core';
import { getEventTypeName } from '../../../api/EventLogger';
import { formatDateTime } from '../../../../api/date';
import { getAlertTypeName } from '../../../api/AlertLogger';

class AlertList_ extends React.Component {

    render(){
        const {t} = this.props

        console.log('this.props.alerts')
        console.log(this.props.alerts)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            }
        };

        return(
            <Paper style={styles.paper}>
                <Table size="small">
                    
                    <TableHead>
                        <TableRow>
                            <TableCell style={styles.head}>{t('AlertType')}</TableCell>
                            <TableCell style={styles.head}>{t('DateTime')}</TableCell>
                            <TableCell style={styles.head}>{t('Dispatcher')}</TableCell>
                            <TableCell style={styles.head}>{t('Source')}</TableCell>
                            <TableCell style={styles.head}>{t('Description')}</TableCell>
                        </TableRow>
                    </TableHead>
                    
                    <TableBody>
                        {this.props.alerts.map(alert=>(
                            <TableRow key={alert.id} >
                                <TableCell>
                                    {t(getAlertTypeName(alert.type))}
                                </TableCell>
                                <TableCell>
                                    {formatDateTime(alert.datetime, 'full_date')}
                                </TableCell>
                                <TableCell>
                                    {alert.dispatcherName}
                                </TableCell>
                                <TableCell>
                                    {alert.fromName}
                                </TableCell>
                                <TableCell>
                                    {alert.content}
                                </TableCell>
                            </TableRow>
                        ))}
                        
                    </TableBody>
                </Table>
            </Paper>
        );

    }

}

/**
 * const fields = [
    'id',
    'type',
    'state',
    'datetime',
    'dispatcherID',
    'dispatcherName',
    'fromID',
    'fromName',
    'content'
]
 */

export const AlertList = withTranslation()(AlertList_);